import { axiosSwagger } from "@/axios";



export const state = {
  // move folder
  moveFolder: {
    loading: false,
    data: [],
  },
  // move folder to folder
  moveFolderToFolder: {
    loading: false,
  }
}


export const getters = {
}


export const mutations = {
  // MOVE FOLDER
  moveFolderLoading: (state, loading) => {
    state.moveFolder.loading = loading;
  },
  setMoveFolderData: (state, data) => {
    state.moveFolder.data = modifyData( data );
  },
  setMoveFolderDataV2: (state, data) => {
    state.moveFolder.data = data;
  },
  // MOVE FOLDER TO FOLDER
  moveFolderToFolderLoading: (state, loading) => {
    state.moveFolderToFolder.loading = loading;
  },
}


export const actions = {
  // MOVE FOLDER
  async readMoveFolder({ commit }, parentId) {
    commit("moveFolderLoading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileFolder/Simple/My/${parentId}/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        commit("setMoveFolderData", response.data);
        commit("moveFolderLoading", false);

        return response;
      })
      .catch(() => {
        commit("moveFolderLoading", false);
      });
  },
  async readMoveFolderV2({ commit }, id) {
    commit("moveFolderLoading", true);

    if(id && id !== null){
      return await axiosSwagger
        .get(`/api/FileFolder/Child/${id}`)
        .then((response) => {
          commit("setMoveFolderDataV2", response.data);
          commit("moveFolderLoading", false);

          return response;
        })
        .catch(() => {
          commit("moveFolderLoading", false);
        });
    }
    else{
      return await axiosSwagger
        .get("/api/FileFolder/My")
        .then((response) => {
          commit("setMoveFolderDataV2", response.data);
          commit("moveFolderLoading", false);

          return response;
        })
        .catch(() => {
          commit("moveFolderLoading", false);
        });
    }
  },
  // eslint-disable-next-line no-unused-vars
  async readMoveFolderByParentId({ commit }, id) {
    return await axiosSwagger
      .get(`/api/FileFolder/GetFileFolderById/${id}`)
      .then((response) => {
        return response;
      });
  },
  // MOVE FOLDER TO FOLDER
  async moveFolderToFolder({ commit }, data) {
    commit("moveFolderToFolderLoading", true);

    return await axiosSwagger
      .post(`/api/FileFolder/Move/${data.destinationFolderId}`, data.moveFolderIds)
      .then((response) => {
        commit("moveFolderToFolderLoading", false);

        return response;
      })
      .catch(() => {
        commit("moveFolderToFolderLoading", false);
      });
  },
}




// modify data for childFolders
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.childFolders = [];
    });

    return arrayData;
  }

  return [];
};